import { styled } from '@uhg-abyss/web/tools/styled';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

export const TabContainer = styled('div', {
  color: '$core.color.brand.100',
  overflow: 'auto hidden',
});

export const premiumTextIconStyle = (mobileScreen: boolean) => ({
  '&.abyss-icon-symbol': {
    marginRight: '12px',
    ...(mobileScreen && {
      marginRight: '$sm',
    }),
  },
});

export const StackDiv = styled('div', {});

export const stackDivStyle = (
  mobileScreen: boolean,
  widgetDesktopScreen?: boolean,
  last: boolean = false
) => ({
  borderBottom: '1px solid $cardBorder',
  marginBottom: last ? '0' : '8px',
  marginTop: '8px',

  padding: '$lg calc((100% - 1200px) / 2)',
  '@media (max-width: 1248px)': {
    padding: '$lg',
  },
  ...(mobileScreen && {
    padding: '$md !important',
  }),
  ...(widgetDesktopScreen && {
    padding: '$md $lg !important',
  }),
});

export const premiumCareSection = (phoneScreen: boolean) => ({
  padding: '0 0 8px 0',
  ...(phoneScreen && {
    paddingBottom: '4px',
    height: '20px',
  }),
});

export const headerText = (mobileScreen) => ({
  ...(mobileScreen && {
    '&.abyss-heading-root': {
      fontSize: '20.25px !important',
      lineHeight: '24px !important',
    },
  }),
});

export const qualityText = (mobileScreen, isGEHAV2) => ({
  '&.abyss-text-root': {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '400',
    color: isGEHAV2 ? '$core.color.brand.100' : '$neutralGray',

    ...(mobileScreen && {
      fontSize: '16px',
      lineHeight: '20px',
    }),
  },
});

export const boardCertificationsDescriptionStyle = (
  mobileScreen,
  isGEHAV2
) => ({
  '&.abyss-text-root': {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: '400',
    color: isGEHAV2 ? '$core.color.brand.100' : '$neutralGray',

    ...(mobileScreen && {
      fontSize: '14px',
      lineHeight: '18px',
    }),
  },
});

export const PopoverContentContainer = styled('div', {
  '.abyss-icon-symbol': {
    width: '24px',
    height: '24px',
    marginLeft: '8px',
  },
});
export const ContentText = styled('div', {
  paddingBottom: '8px',
  '@media (max-width: 464px)': {
    paddingBottom: '16px',
  },
});

export const drawerStyle = {
  'abyss-icon-symbol': {
    marginBottom: '-0.5px',
    '@media (max-width: 744px)': {
      margin: '0 0 0 4px',
    },
  },
};

export const PopoverIcon = styled(IconSymbol, {
  margin: '6px 0 0 4px',
});
